import React from 'react';
import {
  Box,
  CircularProgress,
  Container,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { ReduxState } from '../../../types';
import Page from '../../../components/Layout/Page';
import useStyles from './styles';
import CustomHeader from '../../../components/General/CustomHeader';
import useFetchFarms from '../../../hooks/useFetchFarms';
import useFetchNotifications from '../../../hooks/useFetchNotifications';
import AccountHomeMap from './components/AccountHomeMap';
import WeatherTabs from './components/WeatherTabs';
import NotificationList from '../../../components/Notifications/NotificationList';
import useGoogleMapsLoader from '../../../hooks/useGoogleMapsLoader';

const AccountHomeContent = () => {
  const classes = useStyles({});

  const { isLoaded } = useGoogleMapsLoader();

  useFetchFarms();
  useFetchNotifications();
  if (!isLoaded) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  const SectorBreadcrumb = () => {
    const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
    const title = selectedFarm ? `${selectedFarm.name}` : 'Sectores';
    return <CustomHeader title={title} showBackButton={false} />;
  };

  return (
    <Page className={classes.root} title='Inicio'>
      <Container maxWidth={false} className={classes.containerContainer}>
        <SectorBreadcrumb />
        <Box height='100%' display='flex'>
          <Box display='flex' flexDirection='column' flex={1}>
            <Box display='flex' flexDirection='column' flex={1}>
              <Box flex='4' mb={2} overflow='hidden'>
                <AccountHomeMap />
              </Box>
              <Box flex='0 0 auto' overflow='auto'>
                <WeatherTabs vertical={false} />
              </Box>
            </Box>
          </Box>
          <Box width="335px" ml={2} overflow='scroll'>
            <NotificationList />
          </Box>
        </Box>
      </Container>
    </Page>
  );
};

const AccountHome = () => {
  const { selectedAccount } = useSelector((state: ReduxState) => state.userAccount);

  if (!selectedAccount) {
    return null;
  }

  return <AccountHomeContent />;
};

export default AccountHome;
